import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {connect} from "trim-redux";
import {Translate} from "../../../config/Translate";
import Grid from "@material-ui/core/Grid/Grid";
import Role from "../../components/elements/Role";
import AppCard from "../../components/layouts/components/AppCard";
import OrderImage from '../../../files/img/dashboard/order.png'
import UsersImage from '../../../files/img/dashboard/users.png'
import ProductImage from '../../../files/img/dashboard/product.png'
import PageImage from '../../../files/img/dashboard/pages.png'
import Title from "../../components/elements/Title";
import Button from "@material-ui/core/Button/Button";
import {Link} from "react-router-dom";
import AppAnimate from "../../components/AppAnimate";
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
class Dashboard extends React.Component {
    classes = this.props.classes;

    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={4} justify="center" className="mt-20">
                    <Role type="admin">
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={ProductImage} alt="shop"/>
                                    <Title style={{fontSize:"20px !important"}}>{Translate.manageProducts}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        size="small"
                                        to="/manage/safe-coins"
                                        endIcon={<ArrowForwardRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={UsersImage} alt="shop"/>
                                    <Title style={{fontSize:"20px !important"}}>{Translate.allUsers}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        size="small"
                                        to="/manage/users/view/all"
                                        endIcon={<ArrowForwardRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={OrderImage} alt="shop"/>
                                    <Title style={{fontSize:30}}>{Translate.manageOrders}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        to="/manage/orders"
                                        size="small"
                                        endIcon={<ArrowForwardRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={PageImage} alt="shop"/>
                                    <Title style={{fontSize:30}}>{Translate.managePages}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        to=""
                                        size="small"
                                        endIcon={<ArrowForwardRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                    </Role>
                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    dashboard: state.dashboard,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Dashboard))));